import React, { useState, useEffect, useMemo } from "react";
import { debounce } from "lodash";
import { CrossIcon, SearchIcon } from "../../../assets";
import { EMPTY_STRING } from "../../../constants";

const SearchField = ({
  handleSearch,
  value = EMPTY_STRING,
  className = EMPTY_STRING,
  placeholder = "Search",
}) => {
  const [searchText, setSearchText] = useState(value);

  // Memoized debounce function
  const debouncedHandleSearch = useMemo(
    () => debounce((value) => handleSearch(value), 500),
    [handleSearch]
  );

  const handleChange = (e) => {
    const value = e.target.value;
    setSearchText(value);
    debouncedHandleSearch(value);
  };

  useEffect(() => {
    setSearchText(value);
  }, [value]);

  // Cleanup debounce on unmount
  useEffect(() => {
    return () => {
      debouncedHandleSearch.cancel();
    };
  }, [debouncedHandleSearch]);

  return (
    <div className={`search-field-container mt-4 ${className}`}>
      <input
        type="text"
        placeholder={placeholder}
        className="search-field"
        value={searchText}
        onChange={handleChange}
      />
      <img src={SearchIcon} className="search-field-icon" alt="Search Icon" />
      {searchText && (
        <img
          src={CrossIcon}
          className="search-clear-icon pointer"
          alt="clear search"
          onClick={() => handleChange({ target: { value: EMPTY_STRING } })}
        />
      )}
    </div>
  );
};

export default SearchField;
